export const ROUTES = {
  WELCOME: '/',
  LOGIN: '/login',
  OTP_VERIFICATION: '/otp-verification',
  ADMIN_DASHBOARD: '/admin/dashboard',
  ADMIN_COMPANY: '/admin/company',
  ADMIN_COMPANY_DETAILS: '/admin/company/:companyId',
  ADMIN_ANNOUNCEMENTS: '/admin/announcements',
  ADMIN_PROFILE: '/admin/profile',
  ADMIN_CONTACT_REQUESTS: '/admin/contact-requests',
  ADMIN_BRANDS: '/admin/brands',
  ADMIN_REVIEWS: '/admin/reviews',
  ADMIN_BLOG: '/admin/blog',
  ADMIN_BLOGS: '/admin/blog',
  ADMIN_SETTINGS: '/admin/settings',
};

export const publicRoutes = [
  ROUTES.WELCOME,
  ROUTES.LOGIN,
  ROUTES.OTP_VERIFICATION,
];

export const privateRoutes = [
  ROUTES.ADMIN_DASHBOARD,
  ROUTES.ADMIN_COMPANY,
  ROUTES.ADMIN_COMPANY_DETAILS,
  ROUTES.ADMIN_ANNOUNCEMENTS,
  ROUTES.ADMIN_PROFILE,
  ROUTES.ADMIN_CONTACT_REQUESTS,
  ROUTES.ADMIN_BRANDS,
  ROUTES.ADMIN_REVIEWS,
  ROUTES.ADMIN_BLOG,
  ROUTES.ADMIN_BLOGS,
  ROUTES.ADMIN_SETTINGS,
];

export const isPrivateRoute = (path) => {
  return privateRoutes.some(route => path.startsWith(route));
};

export const isAuthenticated = () => {
  return localStorage.getItem('isAuthenticated') === 'true';
};


